/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Reliability_CaptionInputs */

const en_measure_reliability_caption = /** @type {(inputs: Measure_Reliability_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`of calls succeeded`)
};

const zh_hans1_measure_reliability_caption = /** @type {(inputs: Measure_Reliability_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`的调用成功`)
};

const pt_br2_measure_reliability_caption = /** @type {(inputs: Measure_Reliability_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`das chamadas tiveram sucesso`)
};

const es_measure_reliability_caption = /** @type {(inputs: Measure_Reliability_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de las llamadas tuvieron éxito`)
};

const fr_measure_reliability_caption = /** @type {(inputs: Measure_Reliability_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`des appels ont réussi`)
};

const de_measure_reliability_caption = /** @type {(inputs: Measure_Reliability_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`der Aufrufe erfolgreich`)
};

const ru_measure_reliability_caption = /** @type {(inputs: Measure_Reliability_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`вызовов выполнено успешно`)
};

const it_measure_reliability_caption = /** @type {(inputs: Measure_Reliability_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`delle chiamate riuscite`)
};

/**
* | output |
* | --- |
* | "of calls succeeded" |
*
* @param {Measure_Reliability_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_reliability_caption = /** @type {((inputs?: Measure_Reliability_CaptionInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Reliability_CaptionInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_reliability_caption(inputs)
	if (locale === "pt-BR") return pt_br2_measure_reliability_caption(inputs)
	if (locale === "es") return es_measure_reliability_caption(inputs)
	if (locale === "fr") return fr_measure_reliability_caption(inputs)
	if (locale === "de") return de_measure_reliability_caption(inputs)
	if (locale === "ru") return ru_measure_reliability_caption(inputs)
	if (locale === "it") return it_measure_reliability_caption(inputs)
	return en_measure_reliability_caption(inputs)
});